import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tb-field-group-inner" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "tb-label-eg"
}
const _hoisted_4 = { class: "tb-field-error-msg" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { 
		ref, 
		computed, 
        watch, 
        onMounted
	} from 'vue';
	import { IFieldTextData } from '@/types';

    
export default /*#__PURE__*/_defineComponent({
  name: 'FieldText',
  props: {
    fieldData: null,
    modelValue: null,
    touched: { type: Boolean }
  },
  emits: ['update:modelValue', 'update', 'input'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
		fieldData: IFieldTextData, 
		modelValue: string,
        touched?: boolean
	}

	

	

	const isFocussed = ref(false);
    const isEmpty = ref(!props.modelValue);
    const hasTouched = ref(!!props.touched);
    const hasError = ref(false);
    const hasBlurred = ref(false);
    const currentVal = ref(props.modelValue || '');
    const field = ref(null);

    const componentType = computed((): string => props.fieldData.type == 'textarea' ? 'textarea' : 'input');
	const fieldData = computed((): IFieldTextData => props.fieldData);
	const fieldGroupClass = computed((): Array<string> => [
		'tb-field-group',
        componentType.value == 'textarea' ? 'tb-has-textarea' : '',
		isFocussed.value ? 'tb-focus' : '', 
        isEmpty.value ? '' : 'tb-filled',
		hasError.value ? 'tb-error' : ''
	]);

    const errorMessage = computed((): string => {
        const fieldName = fieldData.value.label.text.replace('?','');
        if (!currentVal.value){
            return `${fieldName || 'This'} is a required field`;
        }
        else if (fieldData.value.type == 'tel'){
            const msg = `${fieldName || 'field'} must be 10 numbers long.`;
            return msg;
        }
        else {
            const msg = `${fieldName || 'field'} is not valid.`;
            return msg;
        }
    });
    const handleFocus = (): void => {
        isFocussed.value = true;
    };
    const handleInput = (): void => {
        const el = (field.value as unknown as HTMLInputElement);
        if (!el) return;

        let val = el.value;
        const maxLength = fieldData.value.maxLength;

        if (maxLength){
            val = val.substring(0, maxLength);
        }
        if (fieldData.value.regex && fieldData.value.regex.length){
            for (var i = 0; i != fieldData.value.regex.length; ++i){
                const r = fieldData.value.regex[i];
                const v = val.replace(r.match, r.replace);
                val = v;
            }
        }
        if (fieldData.value.type == 'tel'){
            let v = val.replace(/[^0-9]/g, '');
            val = v;
        }

        el.value = val;
        isEmpty.value = !val;
        hasTouched.value = true;
        currentVal.value = val;

        validate();

        emits('input', val);
    };
    const handleBlur = (): void => {
        isFocussed.value = false;
        hasBlurred.value = true;
        validate();
    }
    const validate = (): void=> {
        const el = (field.value as unknown as HTMLInputElement);
        if (!el) return;
        const val = el.value;
        const validateFunction = fieldData.value.validation || ((v:any) => true);
        if (validateFunction(val)){
            hasError.value = false;
            emits('update:modelValue', val);
            emits('update', val);
        }
        else if (hasBlurred.value) {
            hasError.value = true;
        }
    }
    const updateModelValue = (val: string) => {
        currentVal.value = val || '';
        handleFocus();
        (field.value as unknown as HTMLInputElement).value = val || '';
        handleInput();
        handleBlur();
    };

    onMounted(() => {
        if (props.modelValue){
            updateModelValue(props.modelValue);
        }
    });

    watch(() => props.touched, () => {
        hasTouched.value = !!props.touched;
        hasBlurred.value = !!props.touched;
        if (props.touched){
            validate();
        }
    });
    watch(() => props.modelValue, (newVal) => {
        if (currentVal.value != newVal){
            updateModelValue(newVal);
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(fieldGroupClass))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        class: "tb-field-label",
        for: _unref(fieldData).id
      }, [
        _createTextVNode(_toDisplayString(_unref(fieldData).label.text) + " ", 1),
        (_unref(fieldData).label.parens)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_unref(fieldData).label.parens) + ")", 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentType)), {
        modelValue: currentVal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentVal).value = $event)),
        ref_key: "field",
        ref: field,
        class: "tb-field",
        type: _unref(fieldData).type || 'text',
        id: _unref(fieldData).id,
        name: _unref(fieldData).name,
        autocomplete: _unref(fieldData).autocomplete,
        maxlength: _unref(fieldData).maxLength,
        rows: _unref(fieldData).rows,
        "data-hj-masked": "",
        onFocus: handleFocus,
        onInput: handleInput,
        onBlur: handleBlur
      }, null, 40, ["modelValue", "type", "id", "name", "autocomplete", "maxlength", "rows"])),
      _createElementVNode("div", _hoisted_4, [
        (hasError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(errorMessage)), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, " "))
      ])
    ])
  ], 2))
}
}

})